import { GsFormSchema } from 'libs/shared/src/components';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { pictureDisplayModeSchemaFor } from './../basics/picture-display-mode.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the video component form.
 * Defines the fields to display for the form.
 */
export const VIDEO_DETAIL_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...ACTIVE_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'height',
      label: 'components.videoDetail.schema.height',
      description: 'components.videoDetail.schema.heightDescription',
      type: 'number',
      min: 100,
      step: 10,
      isResponsive: true,
      nullable: true
    },
    pictureDisplayModeSchemaFor('pictureDisplayMode'),
    {
      formControlName: 'controls',
      label: 'components.videoDetail.schema.controls',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'autoplay',
      label: 'components.videoDetail.schema.autoplay',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'loop',
      label: 'components.videoDetail.schema.loop',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'muted',
      label: 'components.videoDetail.schema.muted',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'showTitle',
      groupingName: 'components.videoDetail.schema.titleSettings',
      label: 'components.videoDetail.schema.showTitle',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'title',
      groupingName: 'components.videoDetail.schema.titleSettings',
      label: 'components.videoDetail.schema.title',
      type: 'text',
      inputType: 'text',
      default: ''
    },
    {
      formControlName: 'showDate',
      label: 'components.videoDetail.schema.showDate',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showDescription',
      label: 'components.videoDetail.schema.showDescription',
      type: 'checkbox',
      default: true
    }
  ]
};
